import {Environment} from "./Environment";

const frontendHost = Environment.frontendHost;
const kiziBackendHost = Environment.kiziBackendHost;
const surebaseBackendHost = Environment.surebaseBackendHost;
const riskBackendHost = Environment.riskBackendHost;
const cognitoClientId = Environment.cognitoClientId;
const cognitoLoginCallbackUrl = `${frontendHost}/login`;
const cognitoLogoutCallbackUrl = `${frontendHost}/logout`;
const cognitoDomainName = `kizi-portal-backend-${Environment.kiziStage}`;
const cognitoHost = `https://${cognitoDomainName}.auth.eu-west-1.amazoncognito.com`;
const cognitoLoginUrl = `${cognitoHost}/login?client_id=${cognitoClientId}&response_type=token&scope=openid&redirect_uri=${cognitoLoginCallbackUrl}`;
const cognitoLogoutUrl = `${cognitoHost}/logout?client_id=${cognitoClientId}&logout_uri=${encodeURIComponent(cognitoLogoutCallbackUrl)}`;
const debug = Environment.debug ?? false;
const autoTranslate = Environment.stage === "dev";
const kiziSubscriptionUrl = Environment.kiziSubscriptionUrl;
const clientNames = [
	"overstappen",
	"consumentenbond",
	"dyme",
	"swift",
	"abnamro",
	"autoverzekeringnl",
	"woolsocks",
	"geldnl",
	"porterenee"
];

export const Configuration = {
	frontendHost,
	kiziBackendHost,
	surebaseBackendHost,
	riskBackendHost,
	clientId: cognitoClientId,
	cognitoLoginCallbackUrl,
	cognitoLogoutCallbackUrl,
	cognitoHost,
	cognitoLoginUrl,
	cognitoLogoutUrl,
	debug,
	autoTranslate,
	kiziSubscriptionUrl,
	clientNames
};
